import {
    AddressForm,
    BackButton,
    Container,
    convertFromBoolean,
    convertToBoolean,
    Divider,
    Form,
    FormDate,
    FormDropDown,
    FormInput,
    FormRadio,
    Header,
    SummaryGroup,
    setAttributeEntity,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import ProfileVehicleUse from './VehicleUse';

const ProfileVehicle = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    const [mode, setMode] = useState('vehicle');
    const [current, setCurrent] = useState(null);

    const getVehicleUses = () => {
        const vehicleUses = [];

        if (props.vehicleUses && props.vehicleUses.filter((x) => x.vehicle === props.vehicle.guid).length > 0) {
            props.vehicleUses
                .filter((x) => x.vehicle === props.vehicle.guid)
                .forEach((vehicleUse) => {
                    const option = { code: 'vehicleUse', value: vehicleUse.guid };

                    let vehicleUseName = (
                        <FormattedMessage key={vehicleUse.guid} id='Profile_Vehicles_Vehicle.newUsage' />
                    );

                    if (props.drivers && vehicleUse.driver && props.drivers.some((x) => x.code === vehicleUse.driver)) {
                        vehicleUseName = `${props.drivers.find((x) => x.code === vehicleUse.driver).value}`;
                    }

                    option.elements = [];

                    option.elements.push({ code: 'Label', value: vehicleUseName });

                    vehicleUses.push(option);
                });
        }

        return vehicleUses;
    };

    const vehicleName =
        props.vehicle?.year && props.vehicle.make
            ? `${props.vehicle.year} ${props.vehicle.make}`
            : `Vehicle ${props.vehicle?.number}`;
    return (
        <React.Fragment>
            {mode === 'vehicle' && (
                <React.Fragment>
                    <BackButton clickEvent={props.backEvent} />
                    <Divider top={sizes.md} />
                    <Header size={sizes.md} textAlign={alignments.left} text={vehicleName} />
                    <Form
                        label={<FormattedMessage id='Profile_Vehicles_Vehicle.vehicleDetails' />}
                        allowEdit={props.allowEdit}
                        saveEvent={() => props.doUpsertPolicy()}
                        cancelEvent={() => props.doGetPolicy()}
                    >
                        <FormInput
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.number' />}
                            value={props.vehicle?.number}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}number`, value })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.year' />}
                            value={props.vehicle?.year}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}year`, value })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.make' />}
                            value={props.vehicle?.make}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}make`, value })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.model' />}
                            value={props.vehicle?.model}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}model`, value })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.vicc' />}
                            value={props.vehicle?.viccCodeExt}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}viccCodeExt`, value })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.vin' />}
                            value={props.vehicle?.vin}
                            changeEvent={(value) => props.doReducePolicyElement({ code: `${props.dotProp}vin`, value })}
                            allowEdit
                        />
                        <FormRadio
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.additionalAlarm' />}
                            value={props.vehicle && { code: convertFromBoolean(props.vehicle.additionalAlarm) }}
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}additionalAlarm`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                        <FormRadio
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.engravings' />}
                            value={props.vehicle && { code: convertFromBoolean(props.vehicle.engravings) }}
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}engravings`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                        <FormRadio
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.tracking' />}
                            value={props.vehicle && { code: convertFromBoolean(props.vehicle.tracking) }}
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}tracking`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                        <FormDropDown
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.garageType' />}
                            value={props.policy?.garageType}
                            references={props.reference.references?.ParkingType}
                            referencesEvent={() => props.reference.doGetReferences('ParkingType')}
                            changeEvent={(value) =>
                                setAttributeEntity(`${props.dotProp}garageType`, value, props.doReducePolicyElement)
                            }
                            allowEdit
                        />
                        <FormRadio
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.garagedAtInsuredAddress' />}
                            value={props.vehicle && { code: convertFromBoolean(props.vehicle.garagedAtInsuredAddress) }}
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}garagedAtInsuredAddress`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                    </Form>
                    {props.vehicle && props.vehicle.garagedAtInsuredAddress === false && (
                        <AddressForm
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.garagingAddress' />}
                            saveEvent={props.doUpsertPolicy}
                            cancelEvent={props.doGetPolicy}
                            reference={props.reference}
                            changeEvent={(dotProp, value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}garageAddress.${dotProp}`, value })
                            }
                            allowEdit={props.allowEdit}
                            address={props.vehicle?.garageAddress}
                        />
                    )}
                    <Form
                        label={<FormattedMessage id='Profile_Vehicles_Vehicle.ownershipDetails' />}
                        allowEdit={props.allowEdit}
                        saveEvent={() => props.doUpsertPolicy()}
                        cancelEvent={() => props.doGetPolicy()}
                    >
                        <FormRadio
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.owned' />}
                            value={props.vehicle && { code: convertFromBoolean(props.vehicle.owned) }}
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}owned`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                        {props.vehicle && props.vehicle.owned === false && (
                            <FormDropDown
                                label={<FormattedMessage id='Profile_Vehicles_Vehicle.lessor' />}
                                value={props.vehicle?.lessor}
                                references={props.reference.references?.AutoFinancer}
                                referencesEvent={() => props.reference.doGetReferences('AutoFinancer')}
                                changeEvent={(value) =>
                                    setAttributeEntity(`${props.dotProp}lessor`, value, props.doReducePolicyElement)
                                }
                                allowEdit
                            />
                        )}
                        {props.vehicle && props.vehicle.owned === true && (
                            <FormRadio
                                label={<FormattedMessage id='Profile_Vehicles_Vehicle.financed' />}
                                value={props.vehicle && { code: convertFromBoolean(props.vehicle.financed) }}
                                references={props.reference.references?.YesNo}
                                referencesEvent={() => props.reference.doGetReferences('YesNo')}
                                changeEvent={(value) =>
                                    props.doReducePolicyElement({
                                        code: `${props.dotProp}financed`,
                                        value: convertToBoolean(value.code),
                                    })
                                }
                                allowEdit
                            />
                        )}
                        {props.vehicle && props.vehicle.financed === true && (
                            <FormDropDown
                                label={<FormattedMessage id='Profile_Vehicles_Vehicle.financerLender' />}
                                value={props.vehicle?.financeLender}
                                references={props.reference.references?.AutoFinancer}
                                referencesEvent={() => props.reference.doGetReferences('AutoFinancer')}
                                changeEvent={(value) =>
                                    setAttributeEntity(
                                        `${props.dotProp}financeLender`,
                                        value,
                                        props.doReducePolicyElement,
                                    )
                                }
                                allowEdit
                            />
                        )}
                        {props.vehicle && props.vehicle.financed === true && (
                            <FormInput
                                label={<FormattedMessage id='Profile_Vehicles_Vehicle.financeRate' />}
                                value={props.vehicle?.financeRate}
                                changeEvent={(value) =>
                                    props.doReducePolicyElement({ code: `${props.dotProp}financeRate`, value })
                                }
                                allowEdit
                            />
                        )}
                        <FormRadio
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.purchasedUsed' />}
                            value={props.vehicle && { code: convertFromBoolean(props.vehicle.used) }}
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}used`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                        <FormDate
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.purchaseDate' />}
                            value={props.vehicle?.purchaseDate}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}purchaseDate`, value })
                            }
                            culture={props.context.session.culture}
                            mode='past'
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.purchaseValue' />}
                            value={props.vehicle?.purchaseValue?.value}
                            changeEvent={(value) => {
                                props.doReducePolicyElement({ code: `${props.dotProp}purchaseValue.value`, value });
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}purchaseValue.currency`,
                                    value: 'cad',
                                });
                            }}
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.currentValue' />}
                            value={props.vehicle?.presentValue?.value}
                            changeEvent={(value) => {
                                props.doReducePolicyElement({ code: `${props.dotProp}presentValue.value`, value });
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}presentValue.currency`,
                                    value: 'cad',
                                });
                            }}
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.newValue' />}
                            value={props.vehicle?.newValue?.value}
                            changeEvent={(value) => {
                                props.doReducePolicyElement({ code: `${props.dotProp}newValue.value`, value });
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}newValue.currency`,
                                    value: 'cad',
                                });
                            }}
                            allowEdit
                        />
                    </Form>
                    <Form
                        label={<FormattedMessage id='Profile_Vehicles_Vehicle.usageDetails' />}
                        allowEdit={props.allowEdit}
                        saveEvent={() => props.doUpsertPolicy()}
                        cancelEvent={() => props.doGetPolicy()}
                    >
                        <FormInput
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.leisureActivity' />}
                            value={props.vehicle?.leisureActivity}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}leisureActivity`, value })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.dailyCommute' />}
                            value={props.vehicle?.commuteActivity}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}commuteActivity`, value })
                            }
                            allowEdit
                        />
                        <FormInput
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.businessActivity' />}
                            value={props.vehicle?.businessActivity}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({ code: `${props.dotProp}businessActivity`, value })
                            }
                            allowEdit
                        />
                        <FormRadio
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.rideshare' />}
                            value={props.vehicle && { code: convertFromBoolean(props.vehicle.rideShare) }}
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}rideShare`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                        <FormRadio
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.winterTires' />}
                            value={props.vehicle && { code: convertFromBoolean(props.vehicle.winterTires) }}
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}winterTires`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                        <FormRadio
                            label={<FormattedMessage id='Profile_Vehicles_Vehicle.storedForWinter' />}
                            value={props.vehicle && { code: convertFromBoolean(props.vehicle.stored) }}
                            references={props.reference.references?.YesNo}
                            referencesEvent={() => props.reference.doGetReferences('YesNo')}
                            changeEvent={(value) =>
                                props.doReducePolicyElement({
                                    code: `${props.dotProp}stored`,
                                    value: convertToBoolean(value.code),
                                })
                            }
                            allowEdit
                        />
                        {props.vehicle && props.vehicle.stored === true && (
                            <FormDate
                                label={<FormattedMessage id='Profile_Vehicles_Vehicle.storageStart' />}
                                value={props.vehicle?.storageStartDate}
                                changeEvent={(value) =>
                                    props.doReducePolicyElement({ code: `${props.dotProp}storageStartDate`, value })
                                }
                                culture={props.context.session.culture}
                                allowEdit
                            />
                        )}
                        {props.vehicle && props.vehicle.stored === true && (
                            <FormDate
                                label={<FormattedMessage id='Profile_Vehicles_Vehicle.storageEnd' />}
                                value={props.vehicle?.storageEndDate}
                                changeEvent={(value) =>
                                    props.doReducePolicyElement({ code: `${props.dotProp}storageEndDate`, value })
                                }
                                culture={props.context.session.culture}
                                allowEdit
                            />
                        )}
                    </Form>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Vehicles_Vehicle.vehicleUsage' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doReduceParameter({ code: 'Vehicle', value: props.vehicle.guid });
                                props.doExecutePolicyAction({ code: 'CREATEVEHICLEUSE' });
                            }}
                            allowEdit
                            editEvent={(vehicleUse) => {
                                setCurrent(vehicleUse);
                                setMode('vehicleUsage');
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(vehicleUse) => {
                                props.doReduceParameter({ code: 'VehicleUse', value: vehicleUse });
                                props.doExecutePolicyAction({ code: 'DELETEVEHICLEUSE' });
                                setCurrent(null);
                                setMode('vehicle');
                            }}
                            entities={getVehicleUses()}
                            icon='person'
                        />
                    </Container>
                </React.Fragment>
            )}
            {mode === 'vehicleUsage' && (
                <ProfileVehicleUse
                    vehicleUse={props.vehicleUses.find((x) => x.guid === current)}
                    dotProp={`vehicleUses.${props.vehicleUses.findIndex((x) => x.guid === current)}.`}
                    backEvent={() => {
                        setMode('vehicle');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReducePolicyElement={props.doReducePolicyElement}
                    reference={props.reference}
                    context={props.context}
                    drivers={props.drivers}
                    allowEdit={props.allowEdit}
                />
            )}
        </React.Fragment>
    );
};

export default ProfileVehicle;
